import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const AccountCardInfo = ({ type, name, value }) => (
  <span>
    <dt
      className={classnames({
        'c-account__term': type !== 'conditions',
        'c-account__conditions': type === 'conditions',
      })}
    >
      {name}
    </dt>
    <dd className={`c-account__${type}`}>{value}</dd>
  </span>
);

AccountCardInfo.propTypes = {
  type: PropTypes.oneOf([
    'sortno',
    'accountno',
    'balance',
    'remaining',
    'conditions',
  ]),
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export const AccountDetailsCard = ({
  accountInfo,
  sortCode,
  accountNumber,
  balance,
  remaining,
  isBalanceDisplayed,
}) => (
  <dl className="c-account__defs">
    {accountInfo.ACC_SORTCODE_LABEL && (
      <AccountCardInfo
        type="sortno"
        name={accountInfo.ACC_SORTCODE_LABEL}
        value={sortCode}
      />
    )}
    <AccountCardInfo
      type="accountno"
      name={accountInfo.ACC_NAME_LABEL}
      value={accountNumber}
    />
    {isBalanceDisplayed && (
      <span>
        <AccountCardInfo
          type="balance"
          name={accountInfo.BALANCE_LABEL}
          value={balance}
        />
        <AccountCardInfo
          type="remaining"
          name={accountInfo.REMAINING_LABEL}
          value={remaining}
        />
        {accountInfo.CONDITION_TITLE && (
          <AccountCardInfo
            type="conditions"
            name={accountInfo.CONDITION_TITLE}
            value={accountInfo.CONDITION_MESSAGE}
          />
        )}
      </span>
    )}
  </dl>
);

AccountDetailsCard.propTypes = {
  accountInfo: PropTypes.shape({
    BALANCE_LABEL: PropTypes.string.isRequired,
    REMAINING_LABEL: PropTypes.string.isRequired,
    ACC_NAME_LABEL: PropTypes.string.isRequired,
    CONDITION_TITLE: PropTypes.string,
    CONDITION_MESSAGE: PropTypes.string,
    ACC_SORTCODE_LABEL: PropTypes.string,
  }).isRequired,
  sortCode: PropTypes.string,
  accountNumber: PropTypes.string.isRequired,
  balance: PropTypes.string.isRequired,
  remaining: PropTypes.string,
  isBalanceDisplayed: PropTypes.bool,
};
